import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from "./store";
import router from "./router";
import i18n from './plugins/i18n';


Vue.config.productionTip = false

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueFirestore from 'vue-firestore';
Vue.use(VueFirestore);


import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon);

window.axios = require('axios');

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);


new Vue({
  i18n,
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

